<template>
  <div>
    <div class="top-bar" :class="[ (!hasBack && !hasClose) ? 'center' : 'between' ]">
      <van-icon v-if="hasBack" class="back-icon" name="arrow-left" @click="goBack" />
      <van-icon v-if="hasClose" class="back-icon" name="arrow-left" />
      <span>{{title}}</span>
      <van-icon class="back-icon" />
    </div>

    <div style="height: 0.5rem;"></div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      hasBack: {
        type: Boolean,
        default: false
      },
      hasClose: {
        type: Boolean,
        default: false
      },
    },
    methods: {
      goBack: function () {
        this.$router.go(-1);
      },
    }

  }
</script>
<style>
  .back-icon {
    width: 0.19rem;
    height: 0.19rem;
  }

  .top-bar {
    display: flex;
    align-items: center;
    height: 0.5rem;
    padding: 0 0.19rem;
    background: #fff;
    border-bottom: 1px solid #eee;
    font-size: 0.18rem;
    box-sizing: border-box;
    position: fixed;
    width: 100%;
    z-index: 1000;
  }

  .center {
    justify-content: center;
  }

  .between {
    justify-content: space-between;
  }
</style>


// WEBPACK FOOTER //
// src/components/common/tabbar.vue